import React from "react";
import ReactECharts from "echarts-for-react";

type ChartSeries = {
  name: string;
  type: "bar" | "line";
  data: number[];
  color: string;
};

interface MixedChartProps {
  title: string;
  xLabels: string[];
  series: ChartSeries[];
}

const MixedChart: React.FC<MixedChartProps> = ({ title, xLabels, series }) => {
  const options = {
    tooltip: { trigger: "axis" },
    legend: {
      data: series.map((s) => s.name),
      bottom: 0,
    },
    xAxis: {
      type: "category",
      data: xLabels,
      axisLine: { lineStyle: { color: "#e5e7eb" } },
      axisLabel: { color: "#6b7280" },
    },
    yAxis: {
      type: "value",
      axisLine: { lineStyle: { color: "#e5e7eb" } },
      axisLabel: { color: "#6b7280" },
    },
    series: series.map((s) => ({
      name: s.name,
      type: s.type,
      smooth: s.type === "line",
      data: s.data,
      lineStyle: { color: s.color },
      itemStyle: { color: s.color },
    })),
  };

  return (
    <div className="bg-white p-6 rounded-3xl w-full shadow">
      <h3 className="text-base font-semibold text-gray-700 mb-4">{title}</h3>
      <ReactECharts option={options} style={{ height: 300, width: "100%" }} />
    </div>
  );
};

export default MixedChart;
